<div class="search-container">
  <form class="search">
    <button mat-icon-button>
      <mat-icon fontIcon="search"></mat-icon>
    </button>
    <input class="search-input" type="text" placeholder="Chercher un produit" #filter
           (keyup)="searchResults(filter.value)">
  </form>
</div>

<div class="tab-container">
  <div *ngFor="let tab of tabContent; index as i"
       (click)="selectTab(i)"
       class="filter"
       [ngClass]="tab.isSelected ? 'selected' : ''"
  >
    {{ tab.title }}
  </div>
</div>


<div class="stock-dashboard">
  <table mat-table [dataSource]="filterStocks(this.appliedFilter)" class="table-container">
    <!-- Position Column -->
    <ng-container matColumnDef="item_name">
      <th mat-header-cell *matHeaderCellDef> Produits</th>
      <td mat-cell *matCellDef="let element"> {{ element.item_name }}</td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="location_id">
      <th mat-header-cell *matHeaderCellDef> Location</th>
      <td mat-cell *matCellDef="let element"> {{ element.location_id }}</td>
    </ng-container>

    <ng-container matColumnDef="production_date">
      <th mat-header-cell *matHeaderCellDef> Production</th>
      <td mat-cell *matCellDef="let element"> {{ formatDateToMMDDYYYY(element.production_date) }}</td>
    </ng-container>

    <ng-container matColumnDef="expiration_date">
      <th mat-header-cell *matHeaderCellDef> Expiration</th>
      <td mat-cell *matCellDef="let element"> {{ formatDateToMMDDYYYY(element.expiration_date) }}</td>
    </ng-container>


    <!-- Name Column -->
    <ng-container matColumnDef="actual_quantity">
      <th mat-header-cell *matHeaderCellDef> Quantité actuelle</th>
      <td mat-cell *matCellDef="let element"> {{ format_price(element.actual_quantity) }}</td>
    </ng-container>

    <!-- Add item icon -->
    <ng-container matColumnDef="item_id_add">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <mat-icon (click)="sendItemToAdd.emit(element)">add_circle_outline</mat-icon>
      </td>
    </ng-container>

    <!-- Remove item icon -->
    <ng-container matColumnDef="item_id_remove">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <mat-icon (click)="sendItemRetire.emit(element)">remove_circle_outline</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row class="header" *matHeaderRowDef="displayedColumns"></tr>
    <tr class="row-dashboard"
        [ngClass]="isExpirationAlerted(row.expiration_date, row.threshold_days) ? 'alerted' : '' "
        mat-row
        *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
